module.exports = __webpack_public_path__ + "static/media/vs.98c6db57.jpg";